import React from 'react';
import Icon from 'assets/Icon';
import Button from 'elements/Button';
import styles from './style/counterField.module.css';
import TextField from './TextField';

interface CounterFieldProps {
  decrement?: Function,
  disabled?: boolean,
  id?: string,
  increment?: Function,
  value?: string | number,
  label?: string,
}

const CounterField = ({
  decrement,
  disabled,
  id,
  increment,
  label,
  value,
}:CounterFieldProps) => (
  <div className={styles.counterField}>
    <TextField
      disabled={disabled}
      handler={() => null}
      id={id}
      label={label}
      value={value}
    />
    <div className={styles.counterField__actions}>
      <Button
        btnSize="small"
        btnStyle="light"
        btnType="icon"
        handler={decrement ? () => decrement() : () => null}
        label="Subtract"
      >
        <Icon icon="Subtract" />
      </Button>
      <Button
        btnSize="small"
        btnStyle="light"
        btnType="icon"
        handler={increment ? () => increment() : () => null}
        label="Add"
      >
        <Icon icon="Add" />
      </Button>
    </div>
  </div>
);

CounterField.defaultProps = {
  decrement: null,
  disabled: false,
  id: null,
  increment: null,
  label: 'Counter Field',
  value: false,
};

export default CounterField;
